import { render, staticRenderFns } from "./SaleHistory.vue?vue&type=template&id=81fc3b06&scoped=true"
import script from "./SaleHistory.vue?vue&type=script&lang=ts"
export * from "./SaleHistory.vue?vue&type=script&lang=ts"
import style0 from "./SaleHistory.vue?vue&type=style&index=0&id=81fc3b06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81fc3b06",
  null
  
)

export default component.exports